<template>
  <div class="pricing-plans-comp"
       :class="[ {'pricing-plans-basic' : planName === $t('plans.basic-title')},
                 {'pricing-plans-border pricing-plans-pro' : planName === $t('plans.pro-title')},
                 {'pricing-plans-master' : planName === $t('plans.master-title')}]">

    <section :class="[planName === $t('plans.pro-title') ? 'pricing-plans-top' : '']" v-if="planName === $t('plans.pro-title')">
      <p>{{ $t('plans.popular-title') }}</p>
    </section>

    <section class="pricing-plans-packedname"
             :class="[  {'plan-basic' : planName === $t('plans.basic-title')},
                    {'plan-pro' : planName === $t('plans.pro-title')},
                    {'plan-master' : planName === $t('plans.master-title')},
                    ]">
      <h4><img class="icon" :src="require(`@/assets/images/${iconPath}`)" alt="">{{ planName }}</h4>

      <span>${{ togglePrice ? priceAnnually :  priceMonthly }}</span>
      <u>95</u>
    </section>

    <section class="pricing-plans-cta">
      <s-button
        class="s-button-upgrade-fill"
        :class="[ {'basic' :  planName === $t('plans.basic-title')},
                  {'pro' : planName === $t('plans.pro-title')},
                  {'master' : planName === $t('plans.master-title')}]"
        btn-link="/payment">{{ $t('actions.buy-now') }}</s-button>

      <small>{{ $t('plans.subscribe-annually-title') }}</small>
      <small>{{ $t('plans.free-subtitle') }}</small>
      <span>{{ togglePrice? $t('plans.will-save-title') +  saveValue : $t('plans.save-title') + saveValue }}</span>

    </section>

    <section class="pricing-plans-details pricing-plans-array" :class="[{'plans-pro' : planName === $t('plans.pro-title')}]">

      <ul class="pricing-plans-list">
        <li v-for="(advantage, index) in advantagesArray" :key="index">
          <span>{{ advantage.item }}</span>
        </li>
      </ul>

    </section>
  </div>
</template>

<script>

import SButton from "@/components/SButton.vue";

export default {
  item: 'PricingPlans',

  components: {
    SButton,
  },
  props: {
    planName: String,
    togglePrice: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      advantagesArrayBasic: [
        { item: this.$t('plans.advantages-basic.1')},
        { item: this.$t('plans.advantages-basic.2')},
        { item: this.$t('plans.advantages-basic.3')},
        { item: this.$t('plans.advantages-basic.4')},
        { item: this.$t('plans.advantages-basic.5')},
        { item: this.$t('plans.advantages-basic.6')},
        { item: this.$t('plans.advantages-basic.7')},
        { item: this.$t('plans.advantages-basic.8')},
        { item: this.$t('plans.advantages-basic.9')},
      ],
      advantagesArrayPro: [
        { item: this.$t('plans.advantages-pro.1')},
        { item: this.$t('plans.advantages-pro.2')},
        { item: this.$t('plans.advantages-pro.3')},
        { item: this.$t('plans.advantages-pro.4')},
        { item: this.$t('plans.advantages-pro.5')},
        { item: this.$t('plans.advantages-pro.6')},
        { item: this.$t('plans.advantages-pro.7')},
        { item: this.$t('plans.advantages-pro.8')},
        { item: this.$t('plans.advantages-pro.9')},
        { item: this.$t('plans.advantages-pro.10')},
      ],
      advantagesArrayMaster: [
        { item: this.$t('plans.advantages-master.1')},
        { item: this.$t('plans.advantages-master.2')},
        { item: this.$t('plans.advantages-master.3')},
        { item: this.$t('plans.advantages-master.4')},
        { item: this.$t('plans.advantages-master.5')},
        { item: this.$t('plans.advantages-master.6')},
        { item: this.$t('plans.advantages-master.7')},
        { item: this.$t('plans.advantages-master.8')},
        { item: this.$t('plans.advantages-master.9')},
        { item: this.$t('plans.advantages-master.10')},
        { item: this.$t('plans.advantages-master.11')},
        { item: this.$t('plans.advantages-master.12')},
        { item: this.$t('plans.advantages-master.13')},
        { item: this.$t('plans.advantages-master.14')},
      ]
    }
  },
  computed: {
    saveValue () {
      switch (this.planName) {
        case this.$t('plans.basic-title'):
          return '$13.90'
        case this.$t('plans.pro-title'):
          return '$19.90'
        case this.$t('plans.master-title'):
          return '$39.90'
        default:
          return ''
      }
    },
    advantagesArray () {
      switch (this.planName) {
        case this.$t('plans.basic-title'):
          return this.advantagesArrayBasic
        case this.$t('plans.pro-title'):
          return this.advantagesArrayPro
        case this.$t('plans.master-title'):
          return this.advantagesArrayMaster
        default:
          return ''
      }
    },
    priceMonthly () {
      switch (this.planName) {
        case this.$t('plans.basic-title'):
          return '6'
        case this.$t('plans.pro-title'):
          return '9'
        case this.$t('plans.master-title'):
          return '19'
        default:
          return ''
      }
    },
    priceAnnually () {
      switch (this.planName) {
        case this.$t('plans.basic-title'):
          return '69'
        case this.$t('plans.pro-title'):
          return '99'
        case this.$t('plans.master-title'):
          return '199'
        default:
          return ''
      }
    },
    iconPath () {
      switch (this.planName) {
        case this.$t('plans.basic-title'):
          return 'SVG/plan_basic_logo_SVG.svg'
        case this.$t('plans.pro-title'):
          return 'SVG/plan_pro_logo_SVG.svg'
        case this.$t('plans.master-title'):
          return 'SVG/plan_master_logo_SVG.svg'
        default:
          return ''
      }
    }
  }
}
</script>
